import { FontWeightProperty } from "csstype";

export const Fonts = {
  Family:
    "Lato, Noto Sans SC, 'Helvetica Neue', HelveticaNeue, Helvetica, Arial, sans-serif",
  Weight: {
    Normal: 400 as FontWeightProperty,
    Bold: 700 as FontWeightProperty,
  },
};
